import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Config from '../config/Config';
import { Container, Button } from 'react-bootstrap';
import { IoArrowBack } from 'react-icons/io5';
import { FaAngleRight } from 'react-icons/fa';
import { FaPassport } from "react-icons/fa";
import { decodeBase64Url } from '../components/Utils';
import { FormattedMessage } from 'react-intl';
import '../css/SecondaryNavbar.css';

const SecondaryNavbar = () => {
  const { mainColor, secondaryNavbarHeight } = Config.appearance;
  const textColor = "#FFFFFF";

  const intl = useIntl();

  const location = useLocation();
  const navigate = useNavigate();

  const pathnames = location.pathname.split('/').filter(x => x);
  const isHomePage = location.pathname === '/';
  const isSearchPage = location.pathname.startsWith('/search');

  let query = new URLSearchParams(location.search).get('query');
  if (query) query = decodeBase64Url(query);

  const handleBackButtonClick = () => navigate('/');

  const getCurrentPageName = () => {
    if (pathnames.length === 0) return null;
    const lastSegment = pathnames[pathnames.length - 1];

    const translationMap = {
      'profile': 'profile',
      'access-control': 'access_control',
      'admin': 'admin_console',
      'not-authorized': 'not_authorized',
    };

    const id = translationMap[lastSegment];
    if (id) {
      return intl.formatMessage({ id }); // provide good defaultMessage in your JSON files
    }

    return lastSegment
      .split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  };

  const currentPageName = getCurrentPageName();

  // Home page: big title only
  if (isHomePage) {
    return (
      <div style={{ backgroundColor: mainColor, height: secondaryNavbarHeight}}>
        <Container style={{ height: '100%' }}>
          <div className="d-flex align-items-center" style={{ height: '100%' }}>
            <h5 style={{ color: textColor, margin: 0, display: 'inline-flex', alignItems: 'center' }}>
              <FaPassport style={{position: 'relative', top: '1px', marginLeft: '4px', marginRight: '18px', fontSize: '25px'}}/>
              <FormattedMessage id="digital_product_passports" />
            </h5>
          </div>
        </Container>
      </div>
    );
  }

return (
    <div style={{ backgroundColor: mainColor, height: secondaryNavbarHeight }}>
      <Container style={{ height: '100%' }}>
        <div className="d-flex align-items-center" style={{ height: '100%' }}>

          {/* Back button – always on search; mobile-only on other pages */}
          <Button
            onClick={handleBackButtonClick}
            variant="link"
            className={`snb-back-btn ${isSearchPage ? '' : 'snb-back-mobile'}`}
          >
            <IoArrowBack style={{ position: 'relative', top: '1px', fontSize: '26px', color: textColor }} />
          </Button>

          {/* Unified breadcrumb */}
          <h5 className="snb-title" style={{ color: textColor, margin: 0 }}>
            {isSearchPage && query ? (
              <span className="snb-text">
                <span className="snb-search-label"><FormattedMessage id="search_result_for" /> </span>{query}
              </span>
            ) : (
              <>
                <Link
                  to="/"
                  className="snb-home-link"
                  style={{ color: textColor, textDecoration: 'none' }}
                >
                  <FaPassport style={{ position: 'relative', top: '1px', marginLeft: '4px', marginRight: '18px', fontSize: '26px' }} />
                  <FormattedMessage id="digital_product_passports" />
                </Link>
                <FaAngleRight className="snb-separator" style={{ margin: '0 12px', fontSize: '16px', position: 'relative', top: '3px', opacity: 0.6 }} />
                <span className="snb-text">
                  {currentPageName}
                </span>
              </>
            )}
          </h5>
        </div>
      </Container>
    </div>
  );
};

export default SecondaryNavbar;